module.exports = __webpack_public_path__ + "img/living_popimgs.f3979c00.png";